import { makeStyles } from "@material-ui/core/index.js";

export default makeStyles((theme) => ({
    button: {
        marginLeft: '15px',
        padding: '4px 12px',
        backgroundColor: '#e8e8e8',
        '&:hover': {
            backgroundColor: '#e8e8e8',
            transform: 'scale(0.98, 0.98)'
        },
    },
    appBar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        zIndex: 100,
        backgroundColor: '#282828',
    },
    toolbar: {
        marginLeft: 'auto',
        display: 'flex',
    },
    brandContainer: {
        marginLeft: '30px',
        display: 'flex',
        alignItems: 'center',
        float: 'left',
    },
    image: {
        marginTop: '4px',
        height: "40px",
        backgroundColor: '#282828',
        [theme.breakpoints.down('sm')]: {
            //height: "36px",
            marginTop: '0px',
        },
    },
    brandName: {
        fontFamily: 'Anaheim',
        fontWeight: '600',
        //color: '#10e0e0',
        //color: '#107090',
        color: '#e2e2e2',
        letterSpacing: '3px',
        fontSize: '20px',
        marginLeft: '16px',
        marginRight: '50px',
        textDecoration: 'none',
        alignSelf: 'flex-end',
        marginBottom: '14px',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    displayMobile: {
        width: '200px',
        padding: '18px 12px',
        margin: '20px 0px 10px 0px',
        boxShadow: 'none',
        backgroundColor: '#e2e2e2',
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
        },
    },
    hideMobile: {
        backgroundColor: '#e8e8e8',
        width: '240px',
        marginLeft: '30px',
        padding: '0px 12px',
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    searchBar: {
        position: 'relative',
        height: '32px',
        fontSize: '16px',
        borderWidth: 0,
        boxSizing: 'border-box',
        outline: 'none',
        borderRadius: '4px',
        '&:hover,&:focus': {
            transform: 'scale(0.99,0.98)',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '15px',
        },
    },
    searchResult: {
        position: 'absolute',
        top: '50px',
        borderRadius: '4px',
        height: 'fit-content',
        width: '240px',
        display: 'none',
        overflow: 'hidden',
        boxShadow: '0px 0px 4px #aaaaaa',
        boxSizing: 'border-box',
        backgroundColor: '#e8e8e8',
    },
    searchResult2: {
        borderRadius: '4px',
        height: 'fit-content',
        width: '200px',
        display: 'none',
        overflow: 'hidden',
        boxSizing: 'border-box',
        backgroundColor: '#e8e8e8',
    },
    userListItem: {
        width: '100%',
        height: '50px',
        borderBottom: '2px solid #dddddd',
        boxSizing: 'border-box',
        alignItems: 'center',
        display: 'flex',
        //justifyContent: 'center',
        flexDirection: 'row',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    userListAvatar: {
        height: '30px',
        width: '30px',
        borderRadius: '17px',
        margin: '0px 8px',
        border: '2px solid #cccccc',
    },
    userListName: {
        flexGrow: 1,
        fontSize: '14px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontWeight: '500',
        color: '#282828',
    },
    noUserError: {
        //width: '100%',
        color: '#383838',
        display: 'flex',
        fontSize: '14px',
        alignItems: 'center',
        fontWeight: '500',
        //textAlign: 'center'
    },
    errorIcon: {
        fontSize: '20px',
        color: '#686868',
        margin: '0px 10px 0px 20px',
    },
    navTab: {
        color: 'white',
        display: 'none',
        marginLeft: '30px',
        textDecorationLine: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    drawerBtn: {
        marginLeft: '15px',
        height: '40px',
        width: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    optionBtn: {
        display: 'none',
        marginLeft: '15px',
        height: '40px',
        width: '40px',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
        },
    },
    optionDiv: {
        display: 'none',
        position: 'fixed',
        width: '240px',
        minWidth: 'fit-content',
        right: '0px',
        top: '64px',
        flexDirection: 'column',
        boxShadow: '2px 0px 16px #282828',
        boxSizing: 'border-box',
        alignItems: 'center',
        padding: '4px 6px',
        zIndex: 21,
        height: '100vh',
        backgroundColor: '#282828',
        [theme.breakpoints.down('xs')]: {
            top: '56px',
        },
    },
    icon: {
        fontSize: '24px',
        color: '#e8e8e8',
        userSelect: 'none',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    avatar: {
        backgroundColor: '#e2e2e2',
        marginLeft: '15px',
        height: '24px',
        width: '24px',
        border: '2px solid #555555',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    chatFrame: {
        boxShadow: '4px 0px 20px #282828',
        position: 'fixed',
        display: 'none',
        right: '0px',
        top: '0px',
        width: '80vw',
        maxWidth: '500px',
        height: '100%',
        backgroundColor: 'violet',
        zIndex: 20,
    },
    profileOptionsDiv: {
        display: 'none',
        position: 'absolute',
        height: 'fit-content',
        width: '100px',
        boxShadow: '0px 0px 4px #585858',
        fontSize: '14px',
        flexDirection: 'column',
        backgroundColor: '#e8e8e8',
        color: '#282828',
        top: '64px',
        right: '60px',
        [theme.breakpoints.down('xs')]: {
            top: '56px',
            right: '50px',
        },
    },
    profileOptionItem: {
        width: '100%',
        boxSizing: 'border-box',
        padding: '8px 12px',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#dddddd',
        },
    },
    profileOptionDivider: {
        width: '100%',
        backgroundColor: '#aaaaaa',
        height: '1px',
    },
    arrowTriangle: {
        position: 'absolute',
        top: '-8px',
        right: '28px',
        height: '0px',
        width: '0px',
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottom: '8px solid #e2e2e2',
    },
    clearIcon: {
        position: 'relative',
        marginLeft: '-28px',
        fontSize: '20px',
        padding: '5px 6px',
        boxSizing: 'border-box',
        color: '#aaaaaa',
        '&:hover': {
            cursor: 'pointer',
            transform: 'scale(1.1,1.1)',
        },
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    clearIconMobile: {
        position: 'absolute',
        top: '36%',
        right: '0px',
        fontSize: '18px',
        padding: '5px 6px',
        boxSizing: 'border-box',
        color: '#888888',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    searchMobileDiv: {
        position: 'relative',
        display: 'flex',
    },
}))

